import { memo, useEffect, useLayoutEffect, useMemo, useState } from "react";
import PayDialog from "../common/PayDialog";
import { Toast } from "react-vant";
import { getShopPayConfig } from "@/api/shop.js"
import { useTranslation } from "react-i18next";;


interface PropType {
    type: number
    closeHandle: (orderID?: string) => void
    teleport?: any
}
const nsfwPay = ({ closeHandle, type, teleport }: PropType) => {
    const [pay, setPay] = useState<any>([])
    const { t } = useTranslation();
    const text = useMemo(() => {
        if (type === 15) {
            return t("components.nsfwPay.ageLimit")
        }
        return t("components.nsfwPay.paymentMethods")
    }, [type])

    useLayoutEffect(() => {
        getPayConfigHandle()
    }, [])
    const getPayConfigHandle = async () => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
        })
        try {
            const { code, data } = await getShopPayConfig(type)
            if (code == "0") {
                let list = data.map((item: any) => {
                    return {
                        ...item,
                        title: type == 15 ? t("components.nsfwPay.a_n") : t("components.nsfwPay.c_n")
                    }
                })
                setPay(list)
            }
            toast.clear()
        } catch (e) {
            toast.clear()
        }

    }
    return (
        <PayDialog teleport={teleport || document.querySelector("body")} dataList={pay} title={t('agent.create.warning')} text={text} text_1={t("components.nsfwPay.purchase")} callBack={(val) => {

            if (val != 'close') {
                console.log(val)
                closeHandle(val)
                // console.log(val)
            } else {
                closeHandle()
            }
        }} />
    )
}


export default nsfwPay